import React from 'react';
import PropTypes from 'prop-types';
export var DocumentLevel = React.createContext(1);
export var NestDocumentLevel = function NestDocumentLevel(_ref) {
  var children = _ref.children;
  return React.createElement(DocumentLevel.Consumer, null, function (level) {
    return React.createElement(DocumentLevel.Provider, {
      value: level + 1
    }, children);
  });
};
export var RootDocumentLevel = function RootDocumentLevel(_ref2) {
  var children = _ref2.children;
  return React.createElement(DocumentLevel.Provider, {
    value: 1
  }, children);
};
NestDocumentLevel.propTypes = {
  children: PropTypes.node.isRequired
};
RootDocumentLevel.propTypes = {
  children: PropTypes.node.isRequired
};